export const supportedCareerLocales=['tr','en','sr','sq','bg','az','ru','de'];

// Country/IP does not determine language. Only local browser preferences are read;
// no geolocation permission, IP lookup or third-party request is made here.
export function initialCareerLocale({saved,browserLanguages=[],browserLanguage}={}) {
  if(supportedCareerLocales.includes(saved))return saved;
  const preferences=[...(Array.isArray(browserLanguages)?browserLanguages:[]),browserLanguage].filter(x=>typeof x==='string'&&x.trim());
  for(const preference of preferences){
    const code=preference.trim().toLowerCase().split(/[-_]/)[0];
    if(supportedCareerLocales.includes(code))return code;
  }
  // International visitors with an unsupported language get English, while
  // environments that provide no browser language retain the Turkish default.
  return preferences.length?'en':'tr';
}
